import { RenderColumnsInterface } from "utilFunctions/shared/CommonTable/CommonTableInterface";
import { useNavigate } from "react-router-dom";
import {
  capitalizeWords,
  roundToAnyDecimalPlaces,
} from "utilFunctions/helperFunctions/utilFunctions";
import {
  ColorCodeInterface,
  RiskColorCode,
} from "utilFunctions/Constants/Constants";
import styled from "styled-components";
import moment from "moment";
import useMasterContext from "Context/MasterContext";
import { useState } from "react";
import { Popover, PopoverBody } from "reactstrap";
import { renderingTime } from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchLecturesTab";
import EditIcon from "Assets/Icons/Editicon";
import DeleteIcon from "Assets/Icons/DeleteIcon";
import ViewIcon from "Assets/Icons/ViewIcon";
import Typography from "Components/CommonComponents/Typography";
import "./index.css";
export const RiskStyledDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 4px;
  padding: 4px;
  width: fit-content;
`;

export const RiskStyledDSpan = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const returnRiskSegment = (segment: string) => {
  const colorCode = RiskColorCode.find(
    (item: ColorCodeInterface) => item.name === segment
  );
  return (
    <RiskStyledDiv color={colorCode?.bgColor}>
      <RiskStyledDSpan color={colorCode?.color}>
        {segment == "NA" ? "Low" : segment}
      </RiskStyledDSpan>
    </RiskStyledDiv>
  );
};

export const displayNumberWithDecimals = (number: any) => {
  if (Number.isInteger(number)) {
    return number.toString(); // Return the integer as a string
  } else {
    return number.toFixed(2); // Return the number with two decimals
  }
};
export const returnFollowUpCount = (followUpCount: any, ptmCount: any) => {
  const markedsvalue: any = [];
  markedsvalue.push({
    label: "Follow-ups :",
    value: followUpCount ? followUpCount : 0,
  });
  markedsvalue.push({
    label: "PTMs :",
    value: ptmCount ? ptmCount : 0,
  });
  return markedsvalue;
};
const RenderColumns = ({
  item,
  value,
  columnValue,
  index,
  extraInformation,
  onEdit,
  onDelete,
  onView,
  handleOverAllratingmodal,
}: RenderColumnsInterface) => {
  const { masters } = useMasterContext();
  const navigate = useNavigate();
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [popoverContent, setPopoverContent] = useState<any>([]);
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);
  const togglePopover = (column: string, content: any) => {
    setHoveredColumn(column);
    setPopoverContent(content);
    setPopoverOpen(!popoverOpen);
  };
  const closePopover = () => {
    setHoveredColumn(null);
    setPopoverOpen(false);
  };
  // const returnStatus = (status: string, item: any) => {
  //   const formattedDate = moment(item.date).format("D MMM YYYY");
  //   return (
  //     <RiskStyledDiv color={status === "1" ? "#E6F4ED" : "#FCEEED"}>
  //       <RiskStyledDSpan color={status === "1" ? "#05945B" : "#E7685A"}>
  //         {status === "1" ? "Active" : "Left on " + formattedDate}
  //       </RiskStyledDSpan>
  //     </RiskStyledDiv>
  //   );
  // };

  const returnStatus = (status: string, item: any) => {
    const formattedDate = moment(item.date).format("D MMM YYYY");
    return (
      <RiskStyledDiv
        color={
          status === null
            ? "rgb(245, 245, 245)"
            : status === "1"
            ? "#E6F4ED"
            : "#FCEEED"
        }
      >
        <RiskStyledDSpan
          color={
            status === null ? "#757575" : status === "1" ? "#05945B" : "#E7685A"
          }
        >
          {/* {status === "1" ? "Active" : "Left on " + formattedDate} */}
          {/* {status === "1"
            ? "Active"
            : formattedDate === "Invalid date"
            ? "Status Not available"
            : "Left on " + formattedDate} */}
          {status === "1"
            ? "Active"
            : status === "0" && item.date !== null
            ? "Left on " + formattedDate
            : status === "0"
            ? "Left"
            : "Status Not available"}
        </RiskStyledDSpan>
      </RiskStyledDiv>
    );
  };

  const routeToPerformance = (item: any) => {
    navigate("/admin/performance/" + item.psid, {
      replace: false,
      state: {
        selectedStudent: item,
      },
    });
  };
  const routeToRegionBranches = (item: any) => {
    if (extraInformation.branchAndRegionIdentifier) {
      navigate("/admin/faculties/branches/" + item.branchOrRegionId, {
        replace: false,
        state: {
          selectedRegion: item,
        },
      });
    } else {
      navigate("/admin/faculties/branch/" + item.branchOrRegionId, {
        replace: false,
        state: {
          selectedBatch: item.branchOrRegionId,
          selectedRegion: extraInformation.regionId,
          selectedStream: extraInformation.streamId,
        },
      });
    }
  };
  const returnRegionName = (arr: any[]) => {
    const array: any[] = [];
    masters?.regions?.map((ele: any) => {
      arr.forEach((item: any) => {
        if (ele.id === item) {
          array.push(ele.label);
        }
      });
    });
    return array;
  };
  const returnBranchName = (arr: any[]) => {
    const array: any[] = [];
    masters?.branches?.map((ele: any) => {
      arr.forEach((item: any) => {
        if (ele.id === item) {
          array.push(ele.label);
        }
      });
    });
    return array;
  };
  const returnMarkedvaluue = (
    message: string,
    markedLectureCount: any,
    unmarkedLectureCount: any
  ) => {
    const markedsvalue: any = [];
    if (item) {
      markedsvalue.push({
        label: "Marked " + message + ":",
        value: markedLectureCount,
      });
      markedsvalue.push({
        label: "Total " + message + ":",
        value: markedLectureCount + unmarkedLectureCount,
      });
    }
    return markedsvalue;
  };
  const returnPercentage = (
    markedLectureCount: any,
    unmarkedLectureCount: any
  ) => {
    const markedLectures = markedLectureCount;
    const unmarkedLectures = unmarkedLectureCount;
    let percentage = 0;
    if (markedLectures != 0 || unmarkedLectures != 0) {
      percentage =
        (Number(markedLectures) /
          (Number(markedLectures) + Number(unmarkedLectures))) *
        100;
      percentage = parseFloat(percentage.toFixed(0));
    }
    return percentage;
  };

  // remove 0 value
  switch (columnValue) {
    default:
      return <td>{value}</td>;
    case "markedAttdCount":
      return (
        <td
          onClick={() =>
            togglePopover(
              "markedAttdCount" + index,
              returnMarkedvaluue(
                "Attendance",
                item.markedAttdCount,
                item.unmarkedAttdCount
              )
            )
          }
          className="hovertableRowcell"
          onMouseLeave={closePopover}
          id={"markedAttdCount" + index}
        >
          <Popover
            placement="bottom"
            isOpen={
              hoveredColumn == "markedAttdCount" + index ? popoverOpen : false
            }
            target={"markedAttdCount" + index}
            toggle={closePopover}
          >
            <PopoverBody className="FacultyTablePopover">
              {popoverContent?.map((ele: any, index: number) => (
                <div
                  key={index}
                  className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                >
                  <div className="d-flex flex-row w-100">
                    <Typography variant="h6" color="black">
                      {ele.label} &nbsp;
                    </Typography>
                    <Typography variant="h6" color="black">
                      {ele.value}
                    </Typography>
                  </div>
                </div>
              ))}
            </PopoverBody>
          </Popover>
          <div
            className={
              returnPercentage(item.markedAttdCount, item.unmarkedAttdCount)
                ? "filterSpan"
                : ""
            }
          >
            {returnPercentage(item.markedAttdCount, item.unmarkedAttdCount)
              ? returnPercentage(item.markedAttdCount, item.unmarkedAttdCount) +
                "%"
              : "-"}
          </div>
        </td>
      );
    case "followUpCount":
      return (
        <td
          onClick={() =>
            togglePopover(
              "followUpCount" + index,
              returnFollowUpCount(item.followUpCount, item.ptmCount)
            )
          }
          className="hovertableRowcell"
          onMouseLeave={closePopover}
          id={"followUpCount" + index}
        >
          <Popover
            placement="bottom"
            isOpen={
              hoveredColumn == "followUpCount" + index ? popoverOpen : false
            }
            target={"followUpCount" + index}
            toggle={closePopover}
          >
            <PopoverBody className="FacultyTablePopover">
              {popoverContent?.map((ele: any, index: number) => (
                <div
                  key={index}
                  className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                >
                  <div className="d-flex flex-row w-100">
                    <Typography variant="h6" color="black">
                      {ele.label} &nbsp;
                    </Typography>
                    <Typography variant="h6" color="black">
                      {ele.value}
                    </Typography>
                  </div>
                </div>
              ))}
            </PopoverBody>
          </Popover>
          <div
            className={
              item.followUpCount + item.ptmCount > 0 ? "filterSpan" : ""
            }
          >
            {item.followUpCount + item.ptmCount > 0
              ? item.followUpCount + item.ptmCount
              : "-"}
          </div>
        </td>
      );

    case "markedLectureCount":
      return (
        <td
          onClick={() =>
            togglePopover(
              "markedLectureCount" + index,
              returnMarkedvaluue(
                "Lectures",
                item.markedLectureCount,
                item.unmarkedLectureCount
              )
            )
          }
          className="hovertableRowcell"
          onMouseLeave={closePopover}
          id={"markedLectureCount" + index}
        >
          <Popover
            placement="bottom"
            isOpen={
              hoveredColumn == "markedLectureCount" + index
                ? popoverOpen
                : false
            }
            target={"markedLectureCount" + index}
            toggle={closePopover}
          >
            <PopoverBody className="FacultyTablePopover">
              {popoverContent?.map((ele: any, index: number) => (
                <div
                  key={index}
                  className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2"
                >
                  <div className="d-flex flex-row w-100">
                    <Typography variant="h6" color="black">
                      {ele.label} &nbsp;
                    </Typography>
                    <Typography variant="h6" color="black">
                      {ele.value}
                    </Typography>
                  </div>
                </div>
              ))}
            </PopoverBody>
          </Popover>
          <div className={"filterSpan"}>
            {returnPercentage(
              item.markedLectureCount,
              item.unmarkedLectureCount
            )}
            %
          </div>
        </td>
      );
    case "studentName":
      return (
        <td>
          <span className="filterSpan" onClick={() => routeToPerformance(item)}>
            {value && capitalizeWords(value)}
          </span>
        </td>
      );
    case "branchOrRegionName":
      return (
        <td>
          <span
            className="filterSpan"
            onClick={() => routeToRegionBranches(item)}
          >
            {item.branchOrRegionName !== null &&
              capitalizeWords(item.branchOrRegionName)}
          </span>
        </td>
      );
    case "riskSegment":
      return (
        <td>
          <div className="d-flex flex-row align-items-center">
            <span className="pr-2">{returnRiskSegment(value)}</span>
            {item.risk > 0 && (
              <span>
                |{"  "}
                {roundToAnyDecimalPlaces(
                  Number(displayNumberWithDecimals(item.risk * 100)),
                  2
                )}{" "}
                %{" "}
              </span>
            )}
          </div>
        </td>
      );
    case "risk":
      return <td></td>;
    case "classAttended":
      return (
        <td>
          {value}/{item.totalClass}
        </td>
      );

    case "status":
      return <td>{returnStatus(value, item)}</td>;
    case "regionId":
      return (
        <td
          onClick={() =>
            togglePopover("regionId" + index, returnRegionName(value))
          }
          onMouseLeave={closePopover}
          id={"regionId" + index}
        >
          <Popover
            placement="bottom"
            isOpen={hoveredColumn == "regionId" + index ? popoverOpen : false}
            target={"regionId" + index}
            toggle={closePopover}
          >
            <PopoverBody className="FacultyTablePopover">
              {popoverContent?.map((ele: any, index: number) => (
                <div
                  key={index}
                  className="branchListing d-flex justify-content-between mb-2"
                >
                  {ele}
                </div>
              ))}
            </PopoverBody>
          </Popover>
          <div className="d-flex gap-2">
            {returnRegionName(value) && returnRegionName(value).length > 1 ? (
              <>
                {returnRegionName(value)[0]}{" "}
                <span className="filterSpan d-flex align-items-center">
                  +{returnRegionName(value)?.length - 1}
                </span>
              </>
            ) : (
              <>{returnRegionName(value)}</>
            )}
          </div>
        </td>
      );

    case "branchId":
      return (
        <td
          onClick={() =>
            togglePopover("branchId" + index, returnBranchName(value))
          }
          onMouseLeave={closePopover}
          id={"branchId" + index}
        >
          <Popover
            placement="bottom"
            isOpen={hoveredColumn == "branchId" + index ? popoverOpen : false}
            target={"branchId" + index}
            toggle={closePopover}
          >
            <PopoverBody className="FacultyTablePopover">
              {popoverContent?.map((ele: any, index: number) => (
                <div
                  key={index}
                  className="branchListing d-flex justify-content-between mb-2"
                >
                  {ele}
                </div>
              ))}
            </PopoverBody>
          </Popover>
          <div className="d-flex gap-2">
            {returnBranchName(value) && returnBranchName(value).length > 1 ? (
              <>
                {returnBranchName(value)[0]}{" "}
                <span className="filterSpan d-flex align-items-center">
                  +{returnBranchName(value)?.length - 1}
                </span>
              </>
            ) : (
              <>{returnBranchName(value)}</>
            )}
          </div>
        </td>
      );
    case "role":
      return (
        <td
          onClick={() => togglePopover("role" + index, value)}
          onMouseLeave={closePopover}
          id={"role" + index}
        >
          <Popover
            placement="bottom"
            isOpen={hoveredColumn == "role" + index ? popoverOpen : false}
            target={"role" + index}
            toggle={closePopover}
          >
            <PopoverBody className="FacultyTablePopover">
              {popoverContent?.map((ele: any, index: number) => (
                <div
                  key={index}
                  className="branchListing d-flex justify-content-between mb-2"
                >
                  {ele}
                </div>
              ))}
            </PopoverBody>
          </Popover>
          <div className="d-flex gap-2">
            {value && value.length > 1 ? (
              <>
                {value[0]}{" "}
                <span className="filterSpan d-flex align-items-center">
                  +{value?.length - 1}
                </span>
              </>
            ) : (
              <>{value}</>
            )}
          </div>
        </td>
      );
    case "scheduleAt":
    case "lastExecutedAt":
      return <td>{value != null && renderingTime(value)} </td>;
    case "notificationAction":
      return (
        <td>
          <EditIcon
            className="cursorHoverCSS p-1"
            onClick={() => {
              onEdit(item);
            }}
          />
          <DeleteIcon
            className="cursorHoverCSS p-1"
            onClick={() => {
              onDelete(item);
            }}
          ></DeleteIcon>
          <ViewIcon
            className="cursorHoverCSS p-1"
            onClick={() => {
              onView(item);
            }}
          ></ViewIcon>
        </td>
      );
    case "overallRatingAvg":
      return (
        <td onClick={() => handleOverAllratingmodal(item)}>
          {item.overallRatingAvg === 0 ? "-" : item.overallRatingAvg}
        </td>
      );
  }
};
export default RenderColumns;
